/* Elm & Harlow: AJAX add-to-cart for vd product cards, header count refresh, toast. */
(function () {
  function toast(msg, ok) {
    var t = document.querySelector('.vd-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'vd-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = msg;
    t.classList.toggle('vd-toast--err', !ok);
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4000);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-vd-add]');
    if (!form || !window.fetch) return;
    if (e.submitter && e.submitter.hasAttribute('data-vd-buynow')) return; /* Buy now: normal post with return_to=/checkout */
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.VDCartDrawer) document.dispatchEvent(new CustomEvent('vd:cart-added'));
        else toast('Added to your cart. <a href="' + root + 'cart">View cart</a>', true);
      })
      .catch(function (err) { toast(err.message, false); })
      .finally(function () { if (btn) btn.disabled = false; });
  });
})();
